<template>
  <footer class="structure" id="site-footer">
    <div class="structure-body">
      <p class="affiliation">
        <small>ウェルスナビ株式会社 金融商品取引業者 関東財務局長（金商）第2884号<br />
          加入協会：日本証券業協会、一般社団法人 資産運用業協会
        </small>
      </p>
      <p class="copyright">
        <small>© WealthNavi Inc. All Rights Reserved.</small>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss">
#site-footer {
  margin: 0;
  padding: 24px 0 30px;
  background: #f7f7f7;
  color: #666;
  font-size: 12px;
  font-family: "Hiragino Kaku Gothic Pro","ヒラギノ角ゴ Pro W3","Yu Gothic",Meiryo,"ＭＳ Ｐゴシック",Helvetica,Arial,Verdana,sans-serif;

  .structure-body {
    margin: 0 auto;
    max-width: none;
  }
  .copyright,
  .affiliation {
    margin: 0;
    padding: 0 15px;
    color: #999;
    text-align: center;
  }
}
</style>
